import { makeSanityClient } from '@eigtech/ui-shared-sanity-docs'

export const sanityClient = makeSanityClient({ projectId: '5mumyhfs' })
